import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { Pencil } from '@jbhi-fi/lanyard-ui/components/Icons';
import React, { ReactNode } from 'react';
import { styles } from './LocationInfoHeader.css';
import { useLocalisationContext } from '../../../context/LocalisationContext';
import { trackingContext, useTracking } from '@jbhi-fi/components/src/Tracking';
import { CUSTOM_EVENT_LOCATION_MODAL_OPENED } from '../constants';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';

export const LocationInfoHeader = ({
  label,
  isDeliveryContainer,
  descriptionFirstLine,
  descriptionSecondLine,
  shouldShowChangeButton = false,
  onClick,
  isNextClosestStoreContainer,
}: {
  label: string;
  isDeliveryContainer: boolean;
  descriptionFirstLine: string;
  descriptionSecondLine?: ReactNode;
  shouldShowChangeButton?: boolean;
  isNextClosestStoreContainer?: boolean;
  onClick?: () => void;
}) => {
  const { isMyLocationOpen, updateMyLocationOpen } = useLocalisationContext();
  const { tracker } = useTracking({
    context: trackingContext.localisation,
    category: 'localisation',
    group: 'pdp-availability',
  });
  const handleClick = () => {
    tracker.trackClick({
      label: `change-location-${isDeliveryContainer ? 'delivery' : 'pick-up'}`,
      source: 'pdp',
      extraData: { value: true },
    });
    if (onClick) {
      onClick();
    } else {
      window.dispatchEvent(new CustomEvent(CUSTOM_EVENT_LOCATION_MODAL_OPENED));
      updateMyLocationOpen(!isMyLocationOpen, 'pdp');
    }
  };

  const containerType = isDeliveryContainer ? 'delivery' : 'pickup';

  return (
    <div
      className={styles.locationSetContainer({ isNextClosestStoreContainer })}
      data-testid={`localisation-${containerType}-header`}
    >
      {!isNextClosestStoreContainer ? (
        <Icon width="2.2em" height="1.5em" name={isDeliveryContainer ? 'TruckIllustrated' : 'StoreIllustrated'} />
      ) : null}
      <div className={styles.locationHeaderText} data-testid={`LocationInfoHeader-header-${containerType}-text`}>
        <span className={styles.locationSetLabel} data-testid={`localisation-${containerType}-header-detail-label`}>
          {label}
        </span>
        <span className={styles.locationSetDetail} data-testid={`localisation-${containerType}-header-detail-value`}>
          {descriptionFirstLine}
          {descriptionSecondLine ? (
            <>
              <br />
              <span className={styles.locationHours} data-testid={`localisation-${containerType}-header-detail-info`}>
                {descriptionSecondLine}
              </span>
            </>
          ) : null}
        </span>
      </div>
      {shouldShowChangeButton ? (
        <div
          className={styles.locationSetChange}
          data-testid={`localisation-${containerType}-header-change-button-wrapper`}
        >
          <Button
            type="linkWithIcon"
            onClick={handleClick}
            label="Change"
            icon={<Pencil />}
            iconPosition="left"
            data-testid="LocationInfoHeader-change-button"
          />
        </div>
      ) : null}
    </div>
  );
};
